import { HTMLAttributes } from "react"

export default function TurbineUI(props: HTMLAttributes<SVGElement>) {
  return (
    <svg width="197" height="196" viewBox="0 0 197 196" fill="none" {...props}>
      <path
        d="M35.6 106.77C17.07 96.0701 10.71 72.3701 21.42 53.8301L88.54 92.5801C77.84 111.11 54.14 117.47 35.6 106.76V106.77Z"
        fill="black"
      />
      <path
        d="M98.12 186.7V109.2C119.52 109.2 136.87 126.55 136.87 147.95C136.87 169.35 119.52 186.7 98.12 186.7Z"
        fill="black"
      />
      <path
        d="M107.71 92.5899C97.01 74.0599 103.36 50.36 121.89 39.65C140.42 28.95 164.12 35.3 174.83 53.83L107.71 92.58V92.5899Z"
        fill="black"
      />
      <path
        d="M85.04 115.41C76.38 121.57 65.88 125.06 54.94 125.06C45.88 125.06 36.94 122.66 29.06 118.11C12.52 108.55 3.23 91.2001 3.16 73.3501C1.1 81.2601 0 89.5601 0 98.1201C0 147.88 37.04 188.98 85.04 195.37V115.41Z"
        fill="black"
      />
      <path
        d="M89.68 78.14C87.84 58.57 97.25 38.77 115.36 28.32C123.24 23.77 132.19 21.37 141.24 21.37C150.29 21.37 159.26 23.82 166.99 28.23C149.27 10.78 124.95 0 98.12 0C66.51 0 38.39 14.95 20.45 38.17L89.68 78.14Z"
        fill="black"
      />
      <path
        d="M188.89 60.8201L119.65 100.8C137.52 108.99 149.96 127.04 149.96 147.95C149.96 167.03 139.6 183.73 124.21 192.73C165.74 181.3 196.24 143.28 196.24 98.1201C196.24 84.9201 193.63 72.3201 188.9 60.8201H188.89Z"
        fill="black"
      />
    </svg>
  )
}
